module.exports = __webpack_public_path__ + "img/help-textarea.8de93b9b.png";